/* eslint-disable prettier/prettier */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { createContext, useState, useEffect } from 'react';
import { DEFAULT_DE_ENFORCEMENT_CONFIG } from '../utils/deEnforcementUtils';
import { DEEnforcementConfig } from '../types/types';
export const FeatureFlagContext = createContext<any>('');
export function FeatureFlagContextProvider(props: any) {
  const [featureFlagDetails, setFeatureFlagDetails] = useState({});
  const [sacRolesLimitDetails, setSacRolesLimitDetails] = useState({});
  const [priceOverrideLimitDetails, setPriceOverrideLimitDetails] = useState({})
  const [termOverrideLimitDetails, setTermOverrideLimitDetails] = useState({})
  const [FindCountry,setFindCountry]=useState<string>();
  const [deEnforcementConfig, setDeEnforcementConfig] = useState<DEEnforcementConfig>(DEFAULT_DE_ENFORCEMENT_CONFIG);


  return (
    <FeatureFlagContext.Provider
        value={{
          featureFlagDetails,
          setFeatureFlagDetails,
          sacRolesLimitDetails,
          setSacRolesLimitDetails,
          priceOverrideLimitDetails,
          setPriceOverrideLimitDetails,
          termOverrideLimitDetails,
          setTermOverrideLimitDetails,
          setFindCountry,
          FindCountry,
          deEnforcementConfig,
          setDeEnforcementConfig
        }}
      >
        {props.children}
      </FeatureFlagContext.Provider>
  );
}
export function MakeFeatureFlagObjFn(storeValue: any) {
  const tempFeatureFlagObj = {};
  for (let i = 0; i < storeValue.length; i++) {
    tempFeatureFlagObj[storeValue[i].paramKeyName] = storeValue[i].paramValue;
  }
  console.log('tempFeatureFlagObj', tempFeatureFlagObj);
  return tempFeatureFlagObj;
}

export function makeSACrolesAllocationFn(req: any) {
  const paramGroupName = 'SACOverrideLimit';
  const paramCategoryName = 'PriceOverride';
  const sacRoleLimitObj = {};

  for (let i = 0; i < req.length; i++) {
    if (
      req[i].paramCategoryName == paramCategoryName &&
      req[i].paramGroupName == paramGroupName
    ) {
      sacRoleLimitObj[req[i].paramKeyName] = Number(req[i].paramValue);
    }
  }


  const SACOverrideRoles = [
    'FSC-CAR',
    'CAR',
    'FSC-AM',
    'AM',
    'FSC-LAM',
    'LAM',
    'FSC-SMT',
    'SMT',
    'FSC-SM',
    'SM',
    'FSC-SSM',
    'SSM',
    'FSC-DMT',
    'DMT',
    'FSC-DM',
    'DM',
    'FSC-RDT',
    'RDT',
    'FSC-RD',
    'RD'
  ];

  const sortedData: any = {};
  for (let i = 0; i < SACOverrideRoles.length; i++) {
    sortedData[SACOverrideRoles[i]] = sacRoleLimitObj[SACOverrideRoles[i]];
  }

  return sortedData;
}




function parseOverrideParamValue(paramValue: string): { min: number; max: number } {
  try {
    const parsed = JSON.parse(paramValue);
    if (typeof parsed === 'object' && parsed !== null && 'min' in parsed && 'max' in parsed) {
      return { min: Number(parsed.min) * 100, max: Number(parsed.max) * 100 };
    }
  } catch {
    console.log("Error Parsing")
  }
  // Fallback for legacy format: treat single value as min, no max limit
  const numericValue = Number(paramValue) * 100;
  return { min: numericValue, max: numericValue };
}

export function makePriceOverRiderolesAllocationFn(req: any) {
  const paramGroupName = 'PriceOverrideLimit';
  const paramCategoryName = 'PriceOverride';
  const priceOverRideRoleLimitObj: any = {};

  for (let i = 0; i < req.length; i++) {
    if (
      req[i]?.paramCategoryName == paramCategoryName &&
      req[i]?.paramGroupName == paramGroupName
    ) {
      priceOverRideRoleLimitObj[req[i]?.paramKeyName] = parseOverrideParamValue(req[i]?.paramValue);
    }
  }
  const PriceOverrideRoles = [
    'FSC-CAR',
    'CAR',
    'RPMT',
    'FSC-AM',
    'AM',
    'FSC-LAM',
    'LAM',
    'FSC-SMT',
    'SMT',
    'FSC-SM',
    'SM',
    'FSC-SSM',
    'SSM',
    'CAM',
    'FSC-DMT',
    'DMT',
    'FSC-DM',
    'DM',
    'FSC-RDT',
    'RDT',
    'FSC-RD',
    'RD'
  ];
  const sortedData: any = {};
  for (let i = 0; i < PriceOverrideRoles.length; i++) {
    sortedData[PriceOverrideRoles[i]] = priceOverRideRoleLimitObj[PriceOverrideRoles[i]];
  }

  return sortedData;
}
export function makeTermOverRiderolesAllocationFn(req: any) {
  const paramGroupName = 'TermOverrideLimit';
  const paramCategoryName = 'PriceOverride';
  const priceOverRideRoleLimitObj: any = {};

  for (let i = 0; i < req.length; i++) {
    if (
      req[i]?.paramCategoryName == paramCategoryName &&
      req[i]?.paramGroupName == paramGroupName
    ) {
      priceOverRideRoleLimitObj[req[i]?.paramKeyName] = parseOverrideParamValue(req[i]?.paramValue);
    }
  }
  const PriceOverrideRoles = [
    'FSC-CAR',
    'CAR',
    'RPMT',
    'FSC-AM',
    'AM',
    'FSC-LAM',
    'LAM',
    'FSC-SMT',
    'SMT',
    'FSC-SM',
    'SM',
    'FSC-SSM',
    'SSM',
    'CAM',
    'FSC-DMT',
    'DMT',
    'FSC-DM',
    'DM',
    'FSC-RDT',
    'RDT',
    'FSC-RD',
    'RD'
  ];
  const sortedData: any = {};
  for (let i = 0; i < PriceOverrideRoles.length; i++) {
    sortedData[PriceOverrideRoles[i]] = priceOverRideRoleLimitObj[PriceOverrideRoles[i]];
  }

  return sortedData;
}
